import { render, staticRenderFns } from "./path-properties.vue?vue&type=template&id=01e828a6&scoped=true"
import script from "./path-properties.ts?vue&type=script&lang=ts&external"
export * from "./path-properties.ts?vue&type=script&lang=ts&external"
import style0 from "./path-properties.less?vue&type=style&index=0&id=01e828a6&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e828a6",
  null
  
)

export default component.exports